<!-- Material Theme -->
<div class="material-container main-material-theme">
    <!-- Main Website -->
    <router-outlet *ngIf="loadMain"></router-outlet>
    <!-- Error Page -->
    <ServiceError *ngIf="loadError" [errorCode]="errorCode"></ServiceError>
</div>